import { render, staticRenderFns } from "./Committee.vue?vue&type=template&id=48954fd2&scoped=true"
import script from "./Committee.vue?vue&type=script&lang=js"
export * from "./Committee.vue?vue&type=script&lang=js"
import style0 from "./Committee.vue?vue&type=style&index=0&id=48954fd2&prod&scoped=true&lang=css"
import style1 from "./Committee.vue?vue&type=style&index=1&id=48954fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48954fd2",
  null
  
)

export default component.exports